import { put, all, call, select, takeLatest } from 'redux-saga/effects';
import { createRequestInstance, watchRequests, sendRequest, success } from 'redux-saga-requests';
import axios from 'axios';
import { createDriver } from 'redux-saga-requests-axios';
import { showLoading } from 'react-redux-loading-bar';
import history from '../common/history';
import {
    POST_STEPONE_APPLICATION,
    FETCH_APPLICATION,
    fetchApplicationQuestions,
    fetchAwards,
    fetchRanks,
    fetchChapters,
    authInit,
    POST_ESCALATE_APPLICATION,
    POST_REDO_APPLICATION,
    POST_ACCEPT_APPLICATION,
    POST_REJECT_APPLICATION,
    POST_CLOSE_APPLICATION, AUTH_REGISTER, fetchAwardCategories, UPDATE_PASSWORD, DE_AUTH, AUTH, POST_CODEX, POST_DKP_EVENT
} from './actions';
import {wsHandling} from './socket';
import {socketSaga} from './socketSagas';

let server = '';
if (process.env.NODE_ENV === 'development') {
    console.log('development mode')
    server = 'http://192.168.1.138:8000';
} else {
    server = 'https://www.addictguild.com'
}

export { server }

const getToken = (state) => state.auth.token;


function* initialize() {
    yield put({type: 'INIT_RESET'});
    const token = yield select(getToken);
    if (token) {
        yield all([
            put({type: 'AUTH_INIT'}),
            put({type: 'FETCH_RANKS'}),
            put({type: 'FETCH_CHAPTERS'}),
            sendRequest(authInit(token), { runOnSuccess: false, runOnError: false }),
            sendRequest(fetchRanks(), { runOnSuccess: false, runOnError: false}),
            sendRequest(fetchChapters(), { runOnSuccess: false, runOnError: false }),
        ])
    } else {
        yield all([
            put({type: 'FETCH_RANKS'}),
            put({type: 'FETCH_CHAPTERS'}),
            sendRequest(fetchRanks(), { runOnSuccess: false, runOnError: false }),
            sendRequest(fetchChapters(), { runOnSuccess: false, runOnError: false }),
        ])
    }
    yield put({type: 'INIT_SUCCESS'});
    yield put({type: 'START_WEBSOCKET'});
    //moved this down to speed things up a bit
    yield put({type: 'FETCH_AWARDS'});
    yield sendRequest(fetchAwards(), { runOnSuccess: false, runOnError: false });
    yield put({type: 'FETCH_AWARD_CATEGORIES'});
    yield sendRequest(fetchAwardCategories(), { runOnSuccess: false, runOnError: false });
}

// Redirect to application detail view
function* appSuccess(response) {
    yield call(history.push, '/applications/'+response.data.id);
}

// Redirect to codex detail view
function* codexRedirect(response) {
    yield call(history.push, '/codex/'+response.data.slug);
}

// Redirect to application detail view
function* dkpEventRedirect(response) {
    yield call(history.push, '/officer/events/'+response.data.slug);
}

function* recruitmentRedirect() {
    yield call(history.push, '/recruitment');
}

function* updatePasswordSuccess() {
    yield call(history.push, '/dashboard');
}

function* restartWebsocket() {
    yield put({type: 'STOP_WEBSOCKET'});
    yield put({type: 'START_WEBSOCKET'});
}

// Get application step 2 questions
function* getQuestions(response) {
    yield put({type: 'FETCH_APPLICATION_QUESTIONS'});
    yield sendRequest(fetchApplicationQuestions(response.data.chapter), {
      runOnSuccess: false,
      runOnError: false, // to prevent endless loop
    });
}

// Append header if it exists
function* onRequestSaga(request, action) {
    //start loading bar
    yield put(showLoading());
    const token = yield select(getToken);
    if (token !== null) {
        return {
            ...request,
            headers:  {
                'Authorization': 'Token ' + token,
                'Content-Type': 'application/json',
                ...request.headers
            }
        }
    } else {
        return request;
    }
}



export default function* rootSaga() {
    yield createRequestInstance({ driver: createDriver(axios.create({ baseURL: server+"/api",})), onRequest: onRequestSaga });
    yield all([
        watchRequests({takeLatest: false}),
        call(initialize),
        wsHandling(),
        socketSaga(),
        takeLatest(success(POST_STEPONE_APPLICATION), appSuccess),
        takeLatest(success(FETCH_APPLICATION), getQuestions),
        takeLatest(success(UPDATE_PASSWORD), updatePasswordSuccess),
        // Redirect to new codex item
        takeLatest(success(POST_CODEX), codexRedirect),
        // Redirect to new event item
        takeLatest(success(POST_DKP_EVENT), dkpEventRedirect),
        // add success for post_escalate etc actions to redirect to /recruitment
        takeLatest(success(POST_ESCALATE_APPLICATION), recruitmentRedirect),
        takeLatest(success(POST_REDO_APPLICATION), recruitmentRedirect),
        takeLatest(success(POST_ACCEPT_APPLICATION), recruitmentRedirect),
        takeLatest(success(POST_REJECT_APPLICATION), recruitmentRedirect),
        takeLatest(success(POST_CLOSE_APPLICATION), recruitmentRedirect),
        // reinitialize on register
        takeLatest(success(AUTH_REGISTER), initialize),
        // restart websocket on login or logout
        takeLatest(success(AUTH), restartWebsocket),
        takeLatest(DE_AUTH, restartWebsocket),
    ]);
}


// WEBPACK FOOTER //
// ./src/redux/sagas.js